import React from 'react';

export default () => <div className="container-fluid">
    <h4>Reports</h4>
</div>